// Homepage load more Shop By Brand
const logoLoadMoreCTA = document.querySelector('.logo-list__load-more');

if (logoLoadMoreCTA !== null) {
  logoLoadMoreCTA.addEventListener('click', function () {
    this.style.display = 'none';

    const logos = this.closest('.logo-list').querySelectorAll('.logo-list__logo');

    for (let i = 0; i < logos.length; i++) {
      logos[i].classList.add('logo-list__mobile-visible');
    }
  });
}